import type { ReactNode } from 'react';

import { FormattedContent } from 'atoms/formatted-content';

import selfie from 'assets/images/vibecheck.jpg';

import css from './styles.module.css';

import raw from './_personal.md' with { type: 'text' };
import vibe from './_vibecheck.md' with { type: 'text' };

export default function Personal(): ReactNode {
	return (
		<main className={css.wrapper}>
			<div className={css.wrap}>
				<h2 data-scroll-reveal>About.</h2>

				<div data-scroll-reveal className={css.inner}>
					<article>
						<FormattedContent raw={raw} wrapperClassName={css.personal} />
					</article>
					<article>
						<figure className={css.selfie}>
							<img src={selfie} loading="lazy" />
						</figure>
						<FormattedContent raw={vibe} wrapperClassName={css.personal} />
					</article>
				</div>
			</div>
		</main>
	);
}
